import React from 'react';
import { ShieldIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="py-12 bg-[#EAF7F3]" data-id="element-103">
      <div className="container mx-auto px-4" data-id="element-104">
        <div className="max-w-3xl mx-auto bg-white p-8 rounded-lg shadow-sm text-center" data-id="element-105">
          <div className="flex justify-center mb-4" data-id="element-106">
            <ShieldIcon size={60} className="text-[#0E6B6B]" data-id="element-107" />
          </div>
          <h2 className="text-2xl md:text-3xl font-serif font-bold mb-4 text-[#0E6B6B]" data-id="element-108">
            Try MyoQuell for 60 Days—No Risk
          </h2>
          <p className="text-lg mb-6" data-id="element-109">
            If you're not completely satisfied with your MyoQuell patches, we'll
            refund your purchase, no questions asked.
          </p>
          <div className="bg-[#EAF7F3] p-4 rounded-lg inline-block" data-id="element-110">
            <h3 className="font-bold mb-2" data-id="element-111">Simple Returns Process:</h3>
            <p className="mb-2" data-id="element-112">
              1. Email us at{' '}
              <a href="mailto:support@myoquell.com" className="text-[#0E6B6B] hover:underline" data-id="element-113">
                support@myoquell.com
              </a>
            </p>
            <p className="mb-2" data-id="element-114">2. Include your order number</p>
            <p data-id="element-115">3. We'll process your refund within 2 business days</p>
          </div>
        </div>
      </div>
    </section>;
}